import "./App.css";
import {
  HashRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./components/header/header";
import Promo from "./components/promo/promo";
import Credit from "./components/credit/credit";
import CreditCard from "./components/creditCard/creditCard";
import Loans from "./components/loans/loans";
import Zaim from "./components/zaim/zaim";
import Footer from "./components/footer/footer";
import Cookies from "./components/cookies/cookies";
import DataProtection from "./components/dataProtection/dataProtection";
import Usage from "./components/usage/usage";
import Contacts from "./components/contacts/contacts";
import Policy from "./components/policy/policy";
import Info from "./components/info/info";

function App() {
  const location = useLocation();

  const showInfo =
    location.pathname === "/credit-card" ||
    location.pathname === "/debit-card" ||
    location.pathname === "/loans" ||
    location.pathname === "/";

  return (
    <div className="App">
      <Header />
      <Promo />
      <div className="container__flex">
        <Routes>
          <Route index path="/" element={<Zaim />} />
          {/* <Route path="/credit-card" element={<CreditCard />} /> */}
          {/* <Route path="/debit-card" element={<Credit />} /> */}
          {/* <Route path="/loans" element={<Loans />} /> */}
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/dataProtection" element={<DataProtection />} />
          <Route path="/usage" element={<Usage />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/policy" element={<Policy />} />
        </Routes>
      </div>
      {showInfo && <Info />}
      <Footer />
    </div>
  );
}

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
